import { useEffect } from 'react';

const handleScroll = (): void => {
  const header = document.querySelector('#header');

  const navPos = header?.getBoundingClientRect().top ?? 0;
  const scrollPos = window.scrollY;

  if (scrollPos > navPos) {
    header?.classList.add('sticky');
  } else {
    header?.classList.remove('sticky');
  }
};

export const useStickyHeader = (): void => {
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
};
